import { Form } from "components/Forms";
import { RichText } from "components/RichTextWidget";
import { useRouter } from "next/router";
import {
  Action,
  Container,
  DownloadFile,
  Heading2,
  Heading6,
  Icon,
  ImageLite,
  ModalWrapper,
  Paragraph,
  RenderIf,
} from "shared/components";
import { VIEW_MODES } from "shared/contexts/ViewMode";
import { useToggle } from "shared/hooks";

import styles from "./Hero030.module.scss";

export const Hero030 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const subtitle = payload?.subtitle ?? "";
  const description = payload?.description ?? "";
  const image = payload?.image ?? {};
  const { attachmentButtonText, file } = payload?.attachment ?? {};
  const { buttonText, form } = payload?.request ?? {};

  const { query } = useRouter();

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.top}>
          <Heading2 className={styles.headline} color="dark">
            {headline}
          </Heading2>
          <Action onClick={onOpen} className={styles.play}>
            <span className={styles.arrow}>
              <Icon className={styles.icon} name="arrow_right" />
            </span>
            <Paragraph color="brand" appearance="bigger">
              {buttonText}
            </Paragraph>
          </Action>
          {opened && (
            <ModalWrapper onCloseModal={onClose}>
              <Form
                item={form}
                metaData={{ page: query.slug }}
                onReset={onClose}
              />
            </ModalWrapper>
          )}
        </div>
        <div className={styles.content}>
          <div className={styles.left}>
            <Heading6 className={styles.subtitle} color="dark">
              {subtitle}
            </Heading6>
            <RenderIf viewMode={VIEW_MODES.MOBILE}>
              <RichText
                className={styles.description}
                value={description}
                color="dark"
              />
            </RenderIf>
            <div className={styles.file}>
              <DownloadFile file={file} label={attachmentButtonText} />
            </div>
          </div>
          <RenderIf viewMode={VIEW_MODES.DESKTOP}>
            <div className={styles.right}>
              <RichText
                className={styles.description}
                value={description}
                color="dark"
              />
            </div>
          </RenderIf>
        </div>
        <ImageLite image={image} className={styles.image} />
      </Container>
    </div>
  );
};

export default Hero030;
